import { Pipe, PipeTransform } from '@angular/core';
import { SchemaStatus } from '../enums/schema-status';
import { TranslocoService } from '@jsverse/transloco';
import { map, Observable } from 'rxjs';

@Pipe({
    name: 'schemaStatus',
    standalone: true
})
export class SchemaStatusPipe implements PipeTransform {
    constructor(private translocoService: TranslocoService) { }

    transform(schemaStatus: SchemaStatus): Observable<string> {
        return this.translocoService.selectTranslateObject<Record<string, string>>("schema").pipe(
            map(status => {
                return status[schemaStatus.toLowerCase()]
            })
        );
    }
}